import styled, { css } from 'vue-styled-components';

import Dropdown from '@/components/Common/Dropdown';

import { GRAY } from '@styles/common.styled';

import {
    GRAY_100_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@styles/common.styled.component';

import { RED } from '@styles/common.styled';

export const deleteCss = css`
    color: ${RED(60)} !important;

    svg {
        fill: ${RED(60)};

        & > path {
            fill: ${RED(60)};
        }
    }
`;

export default {
    props: {
        svgSize: {
            type: String,
            default() {
                return '16px';
            },
        },
        options: {
            type: Array,
            default() {
                return [];
            },
        },
        trigger: {
            type: undefined,
            required: true,
        },
        borderLess: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        visible: {
            type: Boolean,
            default: false,
        },
        disabledHover: {
            type: Boolean,
            default: false,
        },
        arrowIconVisible: {
            type: Boolean,
            default: false,
        },
        formatter: {
            type: Function,
            default: R.prop('text'),
        },
        hideOptionAfterInput: {
            type: Boolean,
            default: true,
        },
        dropdownTrigger: Array,
        placement: String,
        getPopupContainer: Function,
    },
    functional: true,
    render(h, { props, listeners = {} }) {
        const {
            options,
            borderLess,
            arrowIconVisible,
            formatter,
            trigger,
            dropdownTrigger,
            placement,
            hideOptionAfterInput,
            getPopupContainer,
            svgSize,
            disabled,
            disabledHover,
            visible,
        } = props;

        const { visibleChange: change = R.identity } = listeners;

        const makeDropdownOption = (option) => {
            const { Icon, text } = option;
            return {
                icon: Icon && (
                    <DropdownIconWrapper size={svgSize}>
                        {Icon.render ? <Icon v-view-box /> : Icon}
                    </DropdownIconWrapper>
                ),
                text: (
                    <DropdownOptionText class="option-text">
                        {text}
                    </DropdownOptionText>
                ),
                // dropdown items disabled, disableHover
                ...option,
            };
        };

        return (
            <Dropdown
                dropdownTrigger={trigger}
                borderLess={borderLess}
                options={options.map(makeDropdownOption)}
                arrowIconVisible={arrowIconVisible}
                class="with-dropdown"
                formatter={formatter}
                customStyles={DropdownCustomStyles}
                onInput={({ value, index, event }) => {
                    const { cb } = value;
                    cb && cb({ value, index, event });
                }}
                hideOptionAfterInput={hideOptionAfterInput}
                onVisibleChange={change}
                trigger={dropdownTrigger}
                placement={placement}
                getPopupContainer={getPopupContainer}
                // dropdown
                disabled={disabled}
                disabledHover={disabledHover}
                visible={visible}
            />
        );
    },
};

export const DropdownCustomStyles = {
    menuItemHeight: '36px',
    menuItem: css`
        .dropdown-option-text {
            padding: 0 16px;
        }
    `,
};

export const DropdownIconWrapper = styled(FLEX_VERTICAL_CENTER_DIV, {
    size: String,
})`
    svg {
        width: ${R.prop('size')};
        height: ${R.prop('size')};
        fill: ${GRAY(100)};
        margin-right: 8px;
    }

    .lds-ring {
        margin-right: 8px;
    }
`;

export const DropdownOptionText = styled(GRAY_100_DIV)`
    font-size: 13px;
    font-weight: 500;
`;
